<form [formGroup]="form" (submit)="submit()">
  <mat-progress-bar *ngIf="loading" mode="indeterminate" color="primary"></mat-progress-bar>
  <mat-card>
    <mat-card-title>{{ !isNew ? 'Kunde bearbeiten' : 'Neuer Kunde'}}</mat-card-title>
    <mat-card-content class="row">
      <div class="col-md-6">
        <mat-form-field validationInput>
          <input matInput placeholder="Name" class="full-width" formControlName="name" />
        </mat-form-field>
        <h2>Niederlassungen</h2>

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCategory">
          <mat-option *ngFor="let category of categories" [value]="category">
            {{ category?.name }}
          </mat-option>
        </mat-autocomplete>

        <ul class="list-group">
          <li class="list-group-item" *ngFor="let siteAddress of castToFormArray(form.controls['sites']).controls; let i = index"
              [formGroup]="siteAddress">
            <mat-form-field validationInput>
              <input matInput placeholder="Name" class="btn-block" formControlName="name" />
            </mat-form-field>
            <div>
              <mat-form-field validationInput>
                <mat-icon matPrefix>phone</mat-icon>
                <input matInput formControlName="telephone" placeholder="Telefon" />
              </mat-form-field>
              <mat-form-field validationInput>
                <mat-icon matPrefix>mail</mat-icon>
                <input matInput formControlName="email" placeholder="E-Mail" />
              </mat-form-field>
            </div>

            <div [formGroup]="castToFormGroup(siteAddress).controls['address']">
              <mat-form-field validationInput>
                <input matInput placeholder="Straße" class="btn-block" formControlName="street" />
              </mat-form-field>
              <mat-form-field validationInput>
                <input matInput placeholder="PLZ" type="text" formControlName="zip" />
              </mat-form-field>
              <mat-form-field validationInput>
                <input matInput placeholder="Ort" type="text" formControlName="city" />
              </mat-form-field>
            </div>
            <mat-form-field validationInput>
              <input matInput placeholder="Kategorie" type="text" formControlName="category" [matAutocomplete]="auto" />
            </mat-form-field>
            <button mat-mini-fab type="button" (click)="removeSite(siteAddress, i)">
              <mat-icon>delete</mat-icon>
            </button>
          </li>
        </ul>
      </div>
      <div class="col col-md-6">
        <!--<app-opening-hour-form [formArray]="form.controls.openingHours"></app-opening-hour-form>-->
      </div>
      <div class="col-md-6"></div>
    </mat-card-content>
    <button mat-raised-button (click)="addSite()">
      Niederlassung hinzufügen
    </button>
    <mat-card-actions>
      <button mat-raised-button (click)="navigateToCustomer()">
        zurück zum Kunden
      </button>
      <button mat-raised-button color="primary">
        Speichern
      </button>
      <button mat-raised-button type="button" (click)="deleteCustomer()" color="warn">
        Löschen
      </button>
    </mat-card-actions>
  </mat-card>
</form>




// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/customer/customer-form/customer-form.component.html